@use '../../../../app/styles/common/mixins';

.card {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  background-color: var(--surface-01);
  border-radius: 0 0 var(--rounding16) var(--rounding16);
  overflow: hidden;

  @include mixins.laptop {
    flex: 1 1 500px;
    flex-direction: row;
    align-items: stretch;
    gap: var(--spasing20);
    border: 1px solid var(--border-primary);
    border-radius: var(--rounding20);
  }

  @include mixins.desktop {
    flex: 1 1 770px;
  }
}

.offer {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: var(--spasing16);
  padding-top: 0;

  @include mixins.laptop {
    padding: var(--spasing20);
    padding-bottom: 26px;
  }
}

.info {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: var(--spasing12);

  @include mixins.laptop {
    gap: var(--spasing24);
  }
}

.thumb {
  position: relative;
  flex-shrink: 0;
  width: 74px;
  height: 74px;
  overflow: hidden;
  border-radius: var(--rounding08);
  background-color: var(--surface-02);

  @include mixins.tablet {
    width: 74px;
    height: 74px;
    border-radius: 9px;
  }

  @include mixins.laptop {
    width: 130px;
    height: 130px;
    border-radius: var(--rounding16);
  }
}

.thumbButton {
  display: block;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  font: inherit;
}

.thumbImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.5;
}

.thumbBadge {
  position: absolute;
  right: var(--spasing08);
  bottom: var(--spasing08);
  z-index: 2;
}

.body {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}

.price {
  @include mixins.heading-secondary-100;
  color: var(--fg-secondary);

  @include mixins.laptop {
    margin-bottom: var(--spasing24);
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
  }
}

.title {
  @include mixins.heading-primary-300;

  max-width: 95%;
  margin: 0;
  margin-bottom: var(--spasing06);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--fg-secondary);

  @include mixins.tablet {
    @include mixins.heading-primary-300;
  }

  @include mixins.laptop {
    @include mixins.heading-primary-500;
    margin-bottom: var(--spasing08);
  }
}

.badges {
  display: none;

  @include mixins.tablet {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spasing08);
  }
}

.inlineToggle {
  display: flex;
  align-items: center;
  gap: var(--spasing04);
  color: var(--fg-info);
  margin-top: auto;
  margin-bottom: 0;
}

.seller {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spasing12);
  padding: var(--spasing12) var(--spasing16);
  border-top: 1px solid var(--border-secondary);
  text-decoration: none;
  color: var(--fg-primary);

  @include mixins.laptop {
    justify-content: flex-start;
    padding: 0;
    border-top: none;
    margin-top: auto;
  }

  @include mixins.desktop {
    gap: var(--spasing08);
  }

  .sellerAvatar {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    order: 2;

    @include mixins.tablet {
      width: 44px;
      height: 44px;
      order: 0;
    }
  }

  .sellerName {
    @include mixins.heading-secondary-200;
    color: var(--fg-primary);

    @include mixins.tablet {
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;
    }

    @include mixins.laptop {
      @include mixins.heading-primary-300;
    }
  }

  .sellerText {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1 1 auto;
    order: 1;

    @include mixins.tablet {
      order: 0;
      flex: 0 1 auto;
    }
  }

  .sellerNameRow {
    display: flex;
    align-items: center;
    gap: var(--spasing02);
    text-decoration: none;
    color: inherit;

    @include mixins.laptop {
      gap: var(--spasing04);
    }
  }

  .sellerChevron {
    width: 16px;
    height: 16px;
    flex-shrink: 0;

    & path {
      fill: var(--fg-primary);
    }
  }

  .date {
    font-size: 16px;
    font-weight: 400;
    color: var(--fg-secondary);

    @include mixins.laptop {
      @include mixins.caption-primary-450;
    }
  }
}
